// import React, { useMemo, useState } from "react";
// import { MapPin, UserPlus, ShieldAlert } from "lucide-react";
// import { useToast } from "../../components/clients/Toast";
// import { clientsCreate } from "../../../../../api/auth";
// const initial = {
//   full_name: "",
//   phone: "",
//   email: "",
//   city: "",
//   address: "",
//   manualRiskFlag: false,
// };

// export default function ClientAdd() {
//   const toast = useToast();
//   const [form, setForm] = useState(initial);
//   const [touched, setTouched] = useState({});
//   const [submitting, setSubmitting] = useState(false);

//   const errors = useMemo(() => {
//     const e = {};
//     if (!form.full_name.trim()) e.full_name = "Full name is required.";
//     if (!form.phone.trim()) e.phone = "Phone is required.";
//     if (form.email && !/^\S+@\S+\.\S+$/.test(form.email)) e.email = "Invalid email format.";
//     if (!form.city.trim()) e.city = "City is required.";
//     if (!form.address.trim()) e.address = "Address is required.";
//     return e;
//   }, [form]);

//   const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));
//   const mark = (k) => setTouched((t) => ({ ...t, [k]: true }));

//   const onSubmit = async (e) => {
//   e.preventDefault();

//   // if (Object.keys(errors).length) {
//   //   toast.push({
//   //     title: "Fix errors",
//   //     message: "Please correct the highlighted fields.",
//   //   });
//   //   return;
//   // }

//   try {
//     setSubmitting(true);

//     await clientsCreate(form);

//     toast.push({
//       title: "Client Added",
//       message: "Client saved successfully.",
//     });

//     setForm(initial);
//   } catch (err) {
//     toast.push({
//       title: "Error",
//       message: "Failed to create client.",
//     });
//   } finally {
//     setSubmitting(false);
//   }
// };

//   return (
//     <div className="min-h-screen bg-gray-50">
//       <div className="max-w-4xl mx-auto p-6 space-y-5">
//         <header className="flex flex-col gap-2">
//           <div className="text-2xl font-semibold text-gray-900">Add Client</div>
//           <div className="text-sm text-gray-600">
//             Create a new customer profile for scoring and order behavior tracking.
//           </div>
//         </header>

//         <form onSubmit={onSubmit} className="rounded-3xl bg-white border border-gray-100 shadow-sm p-6">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <Field
//               label="Full name"
//               value={form.full_name}
//               onChange={(v) => setField("full_name", v)}
//               onBlur={() => mark("full_name")}
//               error={touched.full_name ? errors.full_name : ""}
//               placeholder="e.g. Sara El Amrani"
//               icon={UserPlus}
//             />
//             <Field
//               label="Phone"
//               value={form.phone}
//               onChange={(v) => setField("phone", v)}
//               onBlur={() => mark("phone")}
//               error={touched.phone ? errors.phone : ""}
//               placeholder="+212 6 ..."
//             />
//             <Field
//               label="Email (optional)"
//               value={form.email}
//               onChange={(v) => setField("email", v)}
//               onBlur={() => mark("email")}
//               error={touched.email ? errors.email : ""}
//               placeholder="name@example.com"
//             />
//             <Field
//               label="City"
//               value={form.city}
//               onChange={(v) => setField("city", v)}
//               onBlur={() => mark("city")}
//               error={touched.city ? errors.city : ""}
//               placeholder="Casablanca"
//               icon={MapPin}
//             />
//           </div>

//           <div className="mt-4">
//             <Field
//               label="Address"
//               value={form.address}
//               onChange={(v) => setField("address", v)}
//               onBlur={() => mark("address")}
//               error={touched.address ? errors.address : ""}
//               placeholder="Street, neighborhood..."
//             />
//           </div>

//           {/* <div className="mt-4 flex items-center justify-between gap-4 rounded-2xl border border-gray-100 bg-indigo-50/40 p-4">
//             <div className="flex items-start gap-3">
//               <div className="p-2 rounded-xl bg-white border border-gray-100">
//                 <ShieldAlert className="h-5 w-5 text-indigo-600" />
//               </div>
//               <div>
//                 <div className="text-sm font-semibold text-gray-900">Manual risk flag</div>
//                 <div className="text-xs text-gray-600 mt-1">
//                   If enabled, client will be treated as risky if their score isn&apos;t strongly safe.
//                 </div>
//               </div>
//             </div>

//             <button
//               type="button"
//               onClick={() => setField("manualRiskFlag", !form.manualRiskFlag)}
//               className={[
//                 "relative inline-flex h-10 w-16 items-center rounded-full transition",
//                 form.manualRiskFlag ? "bg-indigo-600" : "bg-gray-200",
//               ].join(" ")}
//               aria-label="Toggle manual risk flag"
//             >
//               <span
//                 className={[
//                   "inline-block h-8 w-8 transform rounded-full bg-white transition",
//                   form.manualRiskFlag ? "translate-x-7" : "translate-x-1",
//                 ].join(" ")}
//               />
//             </button>
//           </div> */}

//           <div className="mt-6 flex items-center justify-end gap-3">
//             <button
//               type="button"
//               onClick={() => { setForm(initial); setTouched({}); }}
//               className="rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
//             >
//               Reset
//             </button>
//             <button
//               type="submit"
//               disabled={submitting}
//               className="rounded-xl bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 disabled:opacity-50"
//             >
//               {submitting ? "Saving..." : "Save Client"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }

// function Field({ label, value, onChange, onBlur, error, placeholder, icon: Icon }) {
//   return (
//     <div>
//       <label className="text-sm font-semibold text-gray-900">{label}</label>
//       <div className="mt-2 relative">
//         {Icon ? <Icon className="h-4 w-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" /> : null}
//         <input
//           value={value}
//           onChange={(e) => onChange(e.target.value)}
//           onBlur={onBlur}
//           placeholder={placeholder}
//           className={[
//             "w-full rounded-2xl border bg-white px-3 py-2 text-sm outline-none focus:ring-2",
//             Icon ? "pl-9" : "",
//             error ? "border-rose-300 focus:ring-rose-200" : "border-gray-200 focus:ring-indigo-200",
//           ].join(" ")}
//         />
//       </div>
//       {error ? <div className="mt-2 text-xs font-semibold text-rose-600">{error}</div> : null}
//     </div>
//   );
// }
import React, { useMemo, useState } from "react";
import { MapPin, UserPlus, Globe, Mail, Phone, Home } from "lucide-react";
import { useToast } from "../../components/clients/Toast";
import { clientsCreate } from "../../../../../api/auth";

const initial = {
  full_name: "",
  phone: "",
  email: "",
  city: "",
  address: "",
  country: "Morocco", // Zdna country kima f tswira
};

export default function ClientAdd() {
  const toast = useToast();
  const [form, setForm] = useState(initial);
  const [touched, setTouched] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const errors = useMemo(() => {
    const e = {};
    if (!form.full_name.trim()) e.full_name = "Full name is required.";
    if (!form.phone.trim()) e.phone = "Phone is required.";
    if (form.email && !/^\S+@\S+\.\S+$/.test(form.email)) e.email = "Invalid email format.";
    if (!form.city.trim()) e.city = "City is required.";
    if (!form.address.trim()) e.address = "Address is required.";
    if (!form.country.trim()) e.country = "Country is required.";
    return e;
  }, [form]);

  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const mark = (k) => setTouched((t) => ({ ...t, [k]: true }));

  const onSubmit = async (e) => {
    e.preventDefault();

    // Check errors before submitting
    if (Object.keys(errors).length > 0) {
        setTouched({
            full_name: true, phone: true, email: true, city: true, address: true, country: true
        });
        toast.push({ title: "Fix errors", message: "Please correct the highlighted fields." });
        return;
    }

    try {
      setSubmitting(true);
      await clientsCreate(form);

      toast.push({
        title: "Client Added",
        message: "Client saved successfully.",
      });

      setForm(initial);
      setTouched({});
    } catch (err) {
      toast.push({
        title: "Error",
        message: "Failed to create client.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-slate-950 p-4 md:p-10">
      <div className="max-w-4xl mx-auto space-y-6">
        <header className="space-y-2">
          <h1 className="text-3xl font-black text-slate-900 dark:text-slate-100 uppercase tracking-tighter">New Client Profile</h1>
          <p className="text-slate-500 dark:text-slate-500 font-bold text-sm">
            Fill in the information below to create a new customer entry in the database.
          </p>
        </header>

        <form onSubmit={onSubmit} className="bg-white dark:bg-slate-900 rounded-[2.5rem] border border-slate-100 dark:border-slate-800 shadow-xl shadow-slate-200/50 dark:shadow-none p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
            
            <Field
              label="Full Name"
              value={form.full_name}
              onChange={(v) => setField("full_name", v)}
              onBlur={() => mark("full_name")}
              error={touched.full_name ? errors.full_name : ""}
              placeholder="e.g. Kamal Idrissi"
              icon={UserPlus}
            />

            <Field
              label="Phone Number"
              value={form.phone}
              onChange={(v) => setField("phone", v)}
              onBlur={() => mark("phone")}
              error={touched.phone ? errors.phone : ""}
              placeholder="+212 600 000000"
              icon={Phone}
            />

            <Field
              label="Email Address"
              value={form.email}
              onChange={(v) => setField("email", v)}
              onBlur={() => mark("email")}
              error={touched.email ? errors.email : ""}
              placeholder="client@example.com"
              icon={Mail}
            />

            <Field
              label="Country"
              value={form.country}
              onChange={(v) => setField("country", v)}
              onBlur={() => mark("country")}
              error={touched.country ? errors.country : ""}
              placeholder="Morocco"
              icon={Globe}
            />

            <Field
              label="City"
              value={form.city}
              onChange={(v) => setField("city", v)}
              onBlur={() => mark("city")}
              error={touched.city ? errors.city : ""}
              placeholder="Casablanca"
              icon={MapPin}
            />

            <Field
              label="Street Address"
              value={form.address}
              onChange={(v) => setField("address", v)}
              onBlur={() => mark("address")}
              error={touched.address ? errors.address : ""}
              placeholder="Avenue 2 Mars, Appt 4..."
              icon={Home}
            />
          </div>

          <div className="mt-12 flex items-center justify-end gap-4 border-t border-slate-50 dark:border-slate-800 pt-8">
            <button
              type="button"
              onClick={() => { setForm(initial); setTouched({}); }}
              className="px-6 py-3 rounded-2xl text-xs font-black uppercase tracking-widest text-slate-400 dark:text-slate-500 hover:bg-slate-50 dark:hover:bg-slate-800 transition-all"
            >
              Reset Form
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="bg-indigo-600 text-white px-8 py-3 rounded-2xl text-xs font-black uppercase tracking-widest shadow-lg shadow-indigo-200 hover:bg-indigo-700 transition-all disabled:opacity-50 flex items-center gap-2"
            >
              {submitting ? "Saving..." : "Create Client"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, onBlur, error, placeholder, icon: Icon }) {
  return (
    <div className="space-y-2">
      <label className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest ml-1">{label}</label>
      <div className="relative group">
        {Icon && (
          <div className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-300 dark:text-slate-600 group-focus-within:text-indigo-500 dark:group-focus-within:text-indigo-400 transition-colors">
            <Icon size={18} />
          </div>
        )}
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          placeholder={placeholder}
          className={`
            w-full bg-slate-50 dark:bg-slate-800 border-2 rounded-2xl px-4 py-3 text-sm font-bold text-slate-700 dark:text-slate-200 outline-none transition-all
            ${Icon ? "pl-12" : ""}
            ${error
              ? "border-rose-100 dark:border-rose-500/30 focus:border-rose-400 bg-rose-50/30 dark:bg-rose-500/10"
              : "border-transparent focus:border-indigo-500 focus:bg-white dark:focus:bg-slate-900 focus:shadow-md"}
          `}
        />
      </div>
      {error && (
        <div className="text-[10px] font-bold text-rose-500 dark:text-rose-400 ml-1 flex items-center gap-1 uppercase tracking-tight">
          ● {error}
        </div>
      )}
    </div>
  );
}